var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page-content"},[(_vm.id)?_c('CoverSettingView',{ref:"refCoverSettingView"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }